module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Ex80Sz/tc-custom/9781504087520.jpg?1718106504227",
      "alt": "This image is the cover for the book Out of Her Mind"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Out of Her Mind\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A police detective hunts for the connection between a killer and a nightmare-plagued nurse, in this frightening psychological thriller . . . ")]), _c('br'), _c('br'), _vm._v(" ICU nurse Sarah Knowles is suffering from nightmares and memory lapses. She finds a vase of roses on her kitchen table but has no recollection of buying them. And why doesn’t she remember moving her belongings around?  "), _c('br'), _c('br'), _vm._v(" Before she can confide her worries to her friend Anne, Anne goes missing. Meanwhile, DCI Peter Graham is hunting a serial killer known as the Beautician, who is terrorizing the West Yorkshire town of Ledforth. A fingerprint links one of Sarah’s patients at the hospital to the latest murder. What no one realizes is that Sarah has a much more significant connection to the killer—and his preparations for their reunion are almost complete . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sally Hart\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0